import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Unidad } from '../../../_models/unidad';
import { DynamicBarService } from '../../../_components/dynamic-bar/dynamic-bar.service';
import { Meta } from '../../../_models/meta';
import { UnidadFormComponent } from '../unidad-form/unidad-form.component';
import { UnidadEtapasService } from './_services/unidad-etapas.service';
import { Location } from '@angular/common';
import { EstudioService } from '../estudio.service';
import { MetaUnidad } from '../../../_models/meta-unidad';
import { Evento } from '../../../_models/evento';
import { EventoFormComponent } from '../evento-form/evento-form.component';
import { MetaListComponent } from '../meta-list/meta-list.component';
import { CustomAlertService } from '../../../_components/custom-alert/custom-alert.service';
import { MatDialog } from '@angular/material/dialog';
import { MetaRapidaFormComponent } from '../meta-form/meta-rapida-form.component';
import { EventoRapidoFormComponent } from '../evento-form/evento-rapido-form.component';
import { EventoUnidad } from '../../../_models/evento-unidad';
import { MetaCriteriosListComponent } from '../meta-criterios-list/meta-criterios-list.component';
import { RubricaComponent } from './rubrica/rubrica.component';
import { GlmComentariosComponent } from '../../../_components/glm-comentarios/glm-comentarios.component';
import { EventoListComponent } from '../evento-list/evento-list.component';
import { Title } from '@angular/platform-browser';
import { UnidadEventoDetalleComponent } from './unidad-eventos-calendario/unidad-evento-detalle.component';
import { ThrobberService } from '../../../_services/throbber.service';
import { MetaFormInjectorComponent } from '../meta-form-injector/meta-form-injector.component';
import { GLMLanguageService } from 'src/app/_services/glm-language.service';


@Component({
  selector: 'unidad-etapas',
  standalone: false,
  templateUrl: 'unidad-etapas.component.html'
})

export class UnidadEtapasComponent implements OnInit {

  unidad: Unidad;
  ambitos: any;
  areas: any;
  categorias: any;
  cursos: any;
  materiasPeriodo: any;
  profesores: any;
  periodos: any = [];
  tags: any;
  activeTab = 0;
  modalData: any;

  enEdicion = false;
  configDirty = false;
  showFormThrobber = false;
  loadRubrica = false;
  idiomas: any[];

  gapi;

  constructor(private location: Location,
    private route: ActivatedRoute,
    private dynamicBarService: DynamicBarService,
    private unidadEtapasService: UnidadEtapasService,
    private estudioService: EstudioService,
    private customAlertService: CustomAlertService,
    public matDialogRef: MatDialog,
    private cd: ChangeDetectorRef,
    private titleService: Title,
    private throbberService: ThrobberService,
    private languageService: GLMLanguageService) { }

  ngOnInit() {
    const unidadID = this.route.snapshot.paramMap.get('id');

    this.estudioService.getCategorias('AmbitoMeta', true).subscribe(res => this.ambitos = res);
    this.estudioService.getAreas().subscribe(res => this.areas = res);
    this.estudioService.getCategoriasByAgrupador('4,5,11,12').subscribe(res => this.categorias = res);
    this.estudioService.getCursos().subscribe(res => this.cursos = res);
    this.estudioService.getCategorias('TagMeta', false).subscribe(res => this.tags = res);
    this.estudioService.getPeriodos(true).subscribe(res => this.periodos = res);

    this.estudioService.getUnidad(unidadID, true).subscribe(res => {
      this.unidad = this.estudioService.extractData(res);
      this.languageService.setLanguage({ nickName: this.unidad.idioma });
      this.unidadEtapasService.setMaterias(this.unidad.materias);
      this.dynamicBarService.setBarra('estudio-unidad-etapas', { unidad: this.unidad });
      this.titleService.setTitle(`${this.unidad.nombre} - Estudio`);
      this.estudioService.getMateriasByPeriodo(this.unidad.periodo.id).subscribe(materias => this.materiasPeriodo = materias);
      this.estudioService.getProfesores(this.unidad.periodo.id).subscribe(profesores => this.profesores = profesores);
    });

    this.route.fragment.subscribe((fragment: string) => {
      if (!fragment) {
        this.activeTab = 0;
      }
      else if (fragment) {
        this.activeTab = (
          fragment.toLowerCase() === 'metas' ? 0
            : fragment.toLowerCase() === 'evidencias' ? 1
              : fragment.toLowerCase() === 'eventos-aprendizaje' ? 2
                : fragment.toLowerCase() === 'rubrica' ? 3
                  : fragment.toLowerCase() === 'informacion-basica' ? 4
                    : fragment.toLowerCase() === 'clases-perdidas' ? 5
                     : 0
        );
      }
      if (+this.activeTab === 3) {
        this.loadRubrica = true;
      }
      else if (+this.activeTab === 4) {
        this.enEdicion = true;
      }
      else if (+this.activeTab === 5) {

      }
    });

    this.unidadEtapasService.getUnidadEtapasObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.tipo === 'abrir-modal') {
        data.objeto['objetoID'] = typeof data.objetoId !== 'undefined' ? data.objetoId : -1;
        this.abrirModal(data.tipoObjeto, data.objeto);
      }
      if (data.tipo === 'abrir-dialogo') {
        this.abrirDialog(data.tipoObjeto, data.objeto);
      }
    });

    this.estudioService.getEstudioServiceObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.tipo && data.tipo === 'actualizar-meta') {
        const metaUnidad = this.unidad.metas.find(meta => {
          return +meta.meta.id === +data.meta.id;
        });
        metaUnidad.meta = data.meta;
      }
      if (data.tipo && (data.tipo === 'actualizar-lista')) {
        this.unidadEtapasService.conectarConUnidad(data.contexto, this.unidad.id, data.objeto.id).subscribe(resp => {
          if (data.contexto === 'meta') {
            const controlLista = this.unidad.metas.filter(meta => {
              return +meta.meta.id !== +data.objeto.id;
            });
            controlLista.push(new MetaUnidad(this.estudioService.extractData(resp)));
            this.unidad.metas = [];
            this.unidad.metas = controlLista;
          } else if (data.contexto === 'evento') {
            const controlLista = this.unidad.eventos,
              nuevoEventoUnidad = new EventoUnidad(this.estudioService.extractData(resp));
            controlLista.push(nuevoEventoUnidad);
            this.unidad.eventos = [];
            this.unidad.eventos = controlLista;
            if (data.continuar) {
              this.unidadEtapasService.emitAbrirModal(nuevoEventoUnidad.id, 'evento-unidad');
            }
          }
        }, err => {

        });
      }
      if (data.tipo && data.tipo === 'agregar-elemento') {
        if (data.objeto instanceof MetaUnidad) {
          const controlLista = Object.assign([], this.unidad.metas);
          controlLista.push(data.objeto);
          this.unidad.metas = [];
          this.unidad.metas = controlLista;
        }
        if (data.objeto instanceof EventoUnidad) {
          const controlLista = Object.assign([], this.unidad.eventos);
          controlLista.push(data.objeto);
          this.unidad.eventos = [];
          this.unidad.eventos = controlLista;
        }
      }
    });
    this.throbberService.setThrobberState(false);
  }

  onChangeTab(index) {
    const urlFrags = this.location.path(false),
      tab = (+index === 0) ? '#metas'
        : (+index === 1) ? '#evidencias'
          : (+index === 2) ? '#eventos-aprendizaje'
            : (+index === 3) ? '#rubrica'
              : (+index === 4) ? '#informacion-basica' 
                : (+index === 5) ? '#clases-perdidas' : '';

    if (index === 4) {
      this.enEdicion = true;
      this.showFormThrobber = true;
    } else if (index === 3) {
      this.loadRubrica = true;
    } else {
      this.loadRubrica = false;
      this.enEdicion = false;
    }

    this.location.go(`${urlFrags}${tab}`);

  }

  abrirDialog(tipo, objeto?) {
    let dialogo;
    if (tipo === 'meta') {
      dialogo = this.matDialogRef.open(MetaRapidaFormComponent, {
        width: '100%',
        height: '100%',
        maxWidth: '100vw !important',
        maxHeight: 'calc(-64px + 100vh)',
        position: { bottom: '0' },
        disableClose: true,
        data: {
          categorias: this.categorias.find(cat => {
            return +cat.ordenAgrupador === 5;
          }),
          mcps: this.unidad.materias,
          editores: this.unidad.editores
        }
      });
      const sub = dialogo.componentInstance.onSave.subscribe(() => {
        dialogo.close();
      });
      dialogo.afterClosed().subscribe(() => {
        sub.unsubscribe();
      });
    }
    if (tipo === 'evento') {
      dialogo = this.matDialogRef.open(EventoRapidoFormComponent, {
        width: '70%',
        // height: '100%',
        // maxWidth: '100vw !important',
        // maxHeight: 'calc(-64px + 100vh)',
        // position: { bottom: '0' },
        // disableClose: true,
        data: {
          categorias: this.categorias.filter(cat => {
            return +cat.ordenAgrupador === 11 || +cat.ordenAgrupador === 12;
          }),
          mcps: this.unidad.materias,
          editores: this.unidad.editores
        }
      });
      const sub = dialogo.componentInstance.onSave.subscribe((data) => {
        dialogo.close();
        if (data.continuar) {
          this.throbberService.setThrobberState(true);
        }
      });
      dialogo.afterClosed().subscribe(() => {
        sub.unsubscribe();
      });
    }
    if (tipo === 'evento-unidad-detalle') {
      dialogo = this.matDialogRef.open(UnidadEventoDetalleComponent, {
        // width: '100%',
        // height: '100%',
        // maxWidth: '100vw !important',
        // maxHeight: 'calc(-64px + 100vh)',
        position: { bottom: '0' },
        disableClose: true,
        data: {
          categorias: this.categorias.filter(cat => {
            return +cat.ordenAgrupador === 11 || +cat.ordenAgrupador === 12;
          }),
          mcps: this.unidad.materias,
          editores: this.unidad.editores,
          evento: objeto
        }
      });
    }
    if (tipo.indexOf('rubrica') > -1) {
      dialogo = this.matDialogRef.open(RubricaComponent, {
        // width: '100%',
        // height: '100%',
        // maxWidth: '100vw !important',
        // maxHeight: 'calc(-64px + 100vh)',
        position: { bottom: '0' },
        disableClose: true,
        data: {
          rubrica: objeto
        }
      });
      dialogo.afterClosed().subscribe(() => {

      });
    }

  }


  abrirModal(tipo, objeto) {
    let component, inputs, titulo, modalConfig;
    modalConfig = {
      width: '100%',
      left: '0%',
      height: 'calc(100% - 66px)',
      top: '66px',
    };

    if (tipo === 'meta_unidad' || tipo === 'comentarios_meta' || tipo === 'criterios_meta') {
      let metaUnidadID = 0;
      titulo = 'Editar meta: ' + objeto.codigo + ' ' + objeto.id;
      if (objeto == null) {
        objeto = new Meta({ id: 0 });
        titulo = 'Crear meta';
      } else {
        metaUnidadID = this.unidad.metas.find(metaU => +metaU.meta.id === +objeto.id).id;
      }
      component = MetaFormInjectorComponent;
      inputs = {
        meta: objeto,
        cursos: this.cursos,
        categorias: this.categorias.filter(cat => {
          return +cat.ordenAgrupador === 5;
        }),
        areas: this.areas,
        profesores: this.profesores,
        ambitos: this.ambitos,
        tags: this.tags,
        contexto: 'unidad_etapas',
        unidadId: this.unidad.id,
        metaUnidadID,
        tabActiva: tipo === 'comentarios_meta' ? 2 : tipo === 'criterios_meta' ? 1 : 0
      };
    }
    if (tipo === 'importar-metas') {
      component = MetaListComponent;
      inputs = {
        categorias: this.categorias.filter(cat => {
          return +cat.ordenAgrupador === 5;
        }),
        idUnidad: this.unidad.id,
        listaMetas: objeto
      };
      titulo = 'Importar metas';
    }
    if (tipo === 'lista-metas-conectar') {
      const eventoConectar = this.unidad.eventos.find(evento => +evento.id === +objeto.objetoID);
      component = MetaCriteriosListComponent;
      inputs = {
        eventoID: objeto.objetoID,
        evento: eventoConectar,
        listaMetasCriterios: objeto
      };
      titulo = 'Conectar criterios';
    }
    if (tipo === 'evento') {
      titulo = 'Editar evidencia/evento';
      if (objeto == null) {
        objeto = new EventoUnidad(
          {
            id: 0,
            unidad: this.unidad,
            unidadID: this.unidad.id,
            evento: new Evento({ id: 0, resumen: '' }),
            eventoID: 0,
            isActive: true,
            isDeleted: false,
            isEditable: true
          });
        titulo = 'Crear evidencia/evento';
      }
      component = EventoFormComponent;
      inputs = {
        evento: objeto,
        cursos: this.cursos,
        categorias: this.categorias.filter(cat => {
          return +cat.ordenAgrupador === 11 || +cat.ordenAgrupador === 12;
        }),
        areas: this.areas,
        profesores: this.profesores,
        ambitos: this.ambitos,
        tags: this.tags,
        materiasPeriodo: this.unidad.materias,
        contexto: 'unidad_etapas',
        tabActiva: tipo === 'comentarios_evento' ? 1 : 0
      };

    }
    if (tipo === 'importar-eventos') {
      component = EventoListComponent;
      inputs = {
        categorias: this.categorias.filter(cat => {
          return cat.id > 5;
        }),
        idUnidad: this.unidad.id,
        listaEventos: objeto
      };
      titulo = 'Importar Eventos';
    }
    if (tipo === 'evento-unidad' || tipo === 'comentarios_evento') {
      titulo = 'Editar evidencia/evento';
      if (objeto == null) {
        objeto = new Evento({ id: 0, resumen: '' });
        titulo = 'Crear evidencia/evento';
      }
      component = EventoFormComponent;
      inputs = {
        evento: objeto,
        cursos: this.cursos,
        categorias: this.categorias.filter(cat => {
          return +cat.ordenAgrupador === 11 || +cat.ordenAgrupador === 12;
        }),
        areas: this.areas,
        profesores: this.profesores,
        ambitos: this.ambitos,
        tags: this.tags,
        materiasPeriodo: this.unidad.materias,
        contexto: 'unidad_etapas',
        tabActiva: tipo === 'comentarios_evento' ? 1 : 0
      };

      this.throbberService.setThrobberState(false);
    }
    if (tipo === 'unidad') {
      titulo = 'Editar unidad';
      if (objeto == null) {
        objeto = new Meta({ id: 0 });
      }
      component = UnidadFormComponent;
      inputs = {
        unidad: objeto,
        materiasPeriodo: this.materiasPeriodo,
        profesores: this.profesores
        // alumnosIEP: this.alumnosIEP
      };
    }
    if (tipo === 'comentarios_unidad') {
      component = GlmComentariosComponent;
      inputs = {
        comentarios: objeto,
        targetID: this.unidad.id,
        origen: 'unidad'
      };
      titulo = 'Comentarios de la unidad';
      modalConfig = {
        'width': '25%',
        'height': 'calc(100% - 66px)',
        'right': '0',
        'top': '66px',
        'left': 'initial',
      };
    }

    if (component && inputs) {
      this.modalData = {
        component: component,
        inputs: inputs,
        titulo: titulo,
        config: modalConfig
      };
    }
  }

  importar(tipo) {
    if (tipo === 'metas') {
      this.throbberService.setThrobberState(true);
      this.estudioService.getMetasImport(this.unidad.id).subscribe(resp => {
        this.throbberService.setThrobberState(false);
        const metas = this.estudioService.extractData(resp);
        this.abrirModal('importar-metas', metas);
      }, err => {
        this.throbberService.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
        });
      });
    }
    if (tipo === 'eventos') {
      this.throbberService.setThrobberState(true);
      this.estudioService.getEventosImport(this.unidad.id).subscribe(resp => {
        this.throbberService.setThrobberState(false);
        const metas = this.estudioService.extractData(resp);
        this.abrirModal('importar-eventos', metas);
      }, err => {
        this.throbberService.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  setDirty(evt) {
    this.configDirty = evt; // TODO: Usar el estado para prevenir el cambio de la pestaña.
  }

  setThrobberVisibility(estado) {
    this.showFormThrobber = estado;
    this.cd.detectChanges();
  }

}
